export default {
  aiSummary: 'Resumo IA',
  noisy: 'Noisy',
  loadingSummaries: 'Carregando resumos...',
  generating: 'Gerando...',
  feedbackOptional: 'Comentários (opcional)',
  feedbackPlaceholder: 'O que poderia ser melhorado?',
  done: 'Pronto',
  generate: 'Gerar',
  generalSummary: 'Resumo Geral',
  modelQuality: 'Qualidade do Modelo',
  baseSales: 'Vendas Base',
  competition: 'Concorrência',
  pricing: 'Preços',
  distribution: 'Distribuição',
  economic: 'Econômico',
  instantMarketingSales: 'Vendas de Marketing Instantâneo',
  seasonality: 'Sazonalidade',
  componentCorrelations: 'Correlações de Componentes',
  topMediaBySpend: 'Principais Mídias por Investimento',
  topMediaByAttribution: 'Principais Mídias por Atribuição',
  attributionDisparities: 'Disparidades de Atribuição',
  fastSaturatingMedia: 'Mídias de Saturação Rápida',
  saturationAnalysis: 'Análise de Saturação',
  highAndLowRoi: 'ROAS Alto e Baixo',
  mediaChannelStrategies: 'Estratégias de Canais de Mídia',
  mediaChannelCorrelations: 'Correlações de Canais de Mídia',
  errorGeneratingSection: 'Erro ao gerar esta seção'
}
